import React from "react";
import { FormattedMessage } from "react-intl";

import { Schema } from "lib/build/schema";

import { Button } from "src/common/components/Button";
import { Form, FormCustomContainer } from "src/common/components/Form";
import { GridColumn, GridRow } from "src/common/components/Grid";
import { AuthPage } from "src/common/components/Page";
import { TextCenter } from "src/common/components/TextAlign";
import { useQueryParam } from "src/common/hooks/useQueryParam";
import {
	FieldData,
	FieldRenderer,
	FormContextProvider,
	useFormState
} from "src/features/forms";
import { errors, labels, messages } from "src/views/password-reset/messages";
import { useResetPassword } from "src/views/password-reset/useResetPassword";

const validator = Schema.object()
	.properties({
		password: Schema.string().minLength(8),
		passwordAgain: Schema.const(Schema.reference("/password"))
	})
	.sealed();

const errorMessages = {
	password: {
		presence: errors.passwordRequired,
		minLength: errors.passwordMinLength
	},
	passwordAgain: {
		presence: errors.passwordRequired,
		const: errors.passwordConst
	}
};

const fields: { [key: string]: FieldData } = {
	password: {
		type: "field",
		path: ["password"],
		label: labels.password,
		errorMessages: errorMessages.password,
		input: { type: "input", props: { type: "password" } }
	},
	passwordAgain: {
		type: "field",
		path: ["passwordAgain"],
		label: labels.passwordAgain,
		errorMessages: errorMessages.passwordAgain,
		input: { type: "input", props: { type: "password" } }
	}
};

export const PasswordReset: React.FunctionComponent = () => {
	const token = useQueryParam("token") || "";
	const formState = useFormState({ validator });
	const { isSubmitted, isLoading, onSubmit } = useResetPassword(
		token,
		formState.value,
		formState.errors.length === 0
	);
	return (
		<AuthPage>
			<FormContextProvider {...formState}>
				<Form isSubmitted={isSubmitted} onSubmit={onSubmit}>
					<h1>
						<FormattedMessage {...messages.title} />
					</h1>
					<h2>
						<FormattedMessage {...messages.help} />
					</h2>
					<GridRow>
						<GridColumn columnSize={12}>
							<FieldRenderer {...fields.password} />
						</GridColumn>
					</GridRow>
					<GridRow>
						<GridColumn columnSize={12}>
							<FieldRenderer {...fields.passwordAgain} />
						</GridColumn>
					</GridRow>
					<GridRow>
						<GridColumn columnSize={12}>
							<FormCustomContainer>
								<TextCenter>
									<Button type="submit" isLoading={isLoading}>
										<FormattedMessage
											{...messages.submit}
										/>
									</Button>
								</TextCenter>
							</FormCustomContainer>
						</GridColumn>
					</GridRow>
				</Form>
			</FormContextProvider>
		</AuthPage>
	);
};
